<template>
  <page-content>
    <edit-field-header
      :title="title"
      @routerBack="$router.back()"
    />

    <edit-field
      :is-edit="true"
      :fields="fields"
      :row-data="row_data"
      post-api="/role/UpdateRole"
      finish-router="role"
      permission="Role_Edit"
    >
      <template #facility="scope">
        <slot-facility :company-id="scope.rowData.companyID" :facility-id="scope.rowData.facilityID" :row-data="scope.rowData" :is-edit="scope.isEdit" />
      </template>

      <template #module="scope">
        <slot-module :row-data="scope.rowData" :facility-id="scope.rowData.facilityID" />
      </template>
    </edit-field>
  </page-content>
</template>

<script>
import fields, { reloadFieldData } from "@/views/role/fields";
import EditField from "@/components/EditField2";
import EditFieldHeader from "@/components/EditFieldHeader";
import common from "@/common";
import PageContent from "@/components/PageContent";
import SlotFacility from "@/views/role/SlotFacility";
import SlotModule from "@/views/role/SlotModule";

export default {
  name: "Edit",
  components: {
    SlotModule,
    SlotFacility,
    PageContent,
    EditFieldHeader,
    EditField,
    fields
  },
  data() {
    return {
      title: common.getMenuName('role') + ' - ' + common.getI18n('common.edit'),
      id: this.$router.currentRoute.params.id,
      fields,
      row_data: {}
    }
  },
  created() {
    reloadFieldData()
  },
  mounted() {
    this.id = common.decrypt(this.id)
    if (this.id === undefined) {
      this.$router.push({ path: '/' + this.$route.path.split('/')[1] })
      return false
    }
    common.apiGetData('/role/GetRole?roleID='+this.id).then(res => {
      this.row_data = res.data.role
    })
  }
}
</script>

<style scoped>

</style>
